import { render } from "./AutomationsTab.vue?vue&type=template&id=2846efe4&scoped=true"
import script from "./AutomationsTab.vue?vue&type=script&lang=js"
export * from "./AutomationsTab.vue?vue&type=script&lang=js"

import "./AutomationsTab.vue?vue&type=style&index=0&id=2846efe4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2846efe4"]])

export default __exports__